<template>
  <admin-layout
    :title="
      newTemplate
        ? 'Crie um template'
        : `Editar template: ${current_template.name}`
    "
    menu="Templates"
  >
    <div class="row">
      <div class="col-xs-12 col-lg-2"></div>
      <div class="col-lg-8 col-xs-12">
        <div id="new-job-box ">
          <div class="card mt-3">
            <div class="card-body formJov">
              <div class="row justify-content-start">
                <div class="w-100 text-left d-inline">
                  <span class="font-weight-bold">Nome do template: </span>
                  <div class="input-group">
                    <input
                      type="text"
                      v-model="current_template.name"
                      class="form-control px-3"
                      :class="{ 'cursor-not-allowed': !UD_permissions }"
                      :readonly="!UD_permissions"
                      placeholder="Nome do Template"
                    />
                    <div class="input-group-append">
                      <button
                        class="btn btn-danger"
                        :class="{
                          'disabled cursor-not-allowed': !UD_permissions,
                        }"
                        :disabled="!UD_permissions"
                        @click="deleteTemplate"
                      >
                        {{ newTemplate ? "Cancelar" : "Deletar Template" }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 col-xs-12">
                  <div class="mt-3">
                    <templateQuestions
                      v-model="questions"
                      :template_id="template.id"
                      :questions_record="questions_record"
                      :gallery="gallery"
                      :intern="true"
                      :UD_permissions="UD_permissions"
                    />
                  </div>
                </div>
                <div class="w-50 col-xs-12" v-if="UD_permissions">
                  <button
                    :disabled="load || !UD_permissions"
                    @click="save(true)"
                    type="buttom"
                    class="btn full btn-degrade normal-degrade"
                  >
                    <font-awesome-icon v-show="!load" icon="check" />
                    {{ !load ? "Salvar Template" : "" }}
                    <div
                      v-show="load"
                      class="spinner-border text-light"
                      role="status"
                    >
                      <span class="sr-only"></span>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-2 col-xs-12"></div>
      <div class="col-lg-8 col-xs-12">
        <span
          @click="back"
          class="btn mt-3 mb-2 btn btnhoverprimary"
          style="border-radius: 0px"
        >
          <font-awesome-icon icon="chevron-left" class="mr-3" />Voltar a
          listagem de templates
        </span>
      </div>
    </div>
  </admin-layout>
</template>

<script>
import axios from "axios";
import templateQuestions from "../TemplateQuestions/Form.vue";
export default {
  props: [
    "newTemplate",
    "questions_record",
    "template",
    "gallery",
    "UD_permissions",
  ],
  components: { templateQuestions },
  data() {
    return {
      load: false,
      intern: false,
      current_template: {
        id: 0,
      },
      questions: [],
    };
  },
  mounted() {
    this.current_template = this.template;
    if (!this.newTemplate) this.questions = this.questions_record;
    eventBus.$on("saveTemplateQuestions", (questions = false, index) => {
      this.saveTemplateQuestions(questions);
    });
    eventBus.$on("saveTemplate", (_) => {
      this.saveTemplate();
    });
  },
  methods: {
    getVideoInternal() {
      eventBus.$emit("turnOnInternal");
    },
    back() {
      this.saveTemplateQuestions(false);
      this.$inertia.visit("/recruiters/templates", {
        method: "get",
        data: {},
        replace: false,
        preserveState: false,
        preserveScroll: false,
        only: [],
      });
    },
    deleteTemplate() {
      if (this.newTemplate) {
        top.location.href = "/recruiters/templates";
        return;
      }
      let conf = confirm("Tem certeza que deseja deletar este template?");
      if (!conf) return;
      axios
        .delete(`/recruiters/templates/${this.current_template.id}`)
        .then((response) => {
          if (response.data.deleted) {
            this.$toast.success("Deletado com sucesso");
            setTimeout((_) => {
              top.location.href = "/recruiters/templates";
            }, 1500);
          } else
            this.$toast.error(
              "Sinto muito, não foi possivel deletar este template"
            );
        });
    },
    saveTemplate() {
      let url = "/recruiters/templates";
      let method = "post";
      if (!this.newTemplate) {
        url = url + `/edit/${this.current_template.id}`;
        method = "put";
      }

      return axios({
        url,
        method,
        data: {
          templates: {
            name: this.current_template.name,
          },
        },
      });
    },
    async save(notify = false) {
      this.load = true;
      const response = await this.saveTemplate();
      if (response.data.created || response.data.updated) {
        this.current_template = response.data.template;
        this.saveTemplateQuestions(this.questions, notify);
      } else {
        this.load = false;
        this.$toast.error("Sinto muito, não foi possivel salvar o template");
      }
    },
    saveTemplateQuestions(questions = false, notify = false) {
      let operation = this.newTemplate
        ? "Template criado com sucesso!"
        : "Template editado com sucesso!";
      let questions_current = [];
      if (questions) {
        this.questions = questions;
      }

      for (let i in this.questions) {
        questions_current.push({
          id: this.questions[i].id,
          title: this.questions[i].title,
          description: this.questions[i].description,
          time: this.questions[i].time,
          number_retakers: this.questions[i].number_retakers,
          details: this.questions[i].details,
          template_id: this.questions[i].template_id,
          video_id: this.questions[i].video_id,
          choices: this.questions[i].choices,
          response_type: this.questions[i].response_type,
        });
      }

      axios
        .post("/recruiters/templates/questions", {
          questions: {
            template_id: this.current_template.id,
            itens: questions_current,
          },
        })
        .then((response) => {
          if (!questions && !notify) {
            return;
          }
          if (!questions.length || notify) {
            this.$toast.success(operation);
            this.load = false;
          }
        })
        .catch((error) => {
          this.load = false;
          console.log(error);
        });
    },
  },
};
</script>